
const api = "https://www.vcmultichannel.com/wp-json/wp/v2"
const menuapi = "https://www.vcmultichannel.com/wp-json/wp-api-menus/v2"
const menuapivc = "https://www.vcmultichannel.com/wp-json/vc/v1"
const emailapi = "https://www.vcmultichannel.com/email.php"
const locationapi = "https://www.vcmultichannel.com/wp-json/location/v1"
const drivegoogle = "https://spreadsheets.google.com/feeds/"


// Generate a unique token for storing your bookshelf data on the backend server.
let token = localStorage.token
if (!token)
  token = localStorage.token = Math.random().toString(36).substr(-8)



const headers = {
  'Accept': 'application/json',
  'Authorization': token
}


export const getLocation = async () => {
  const date = localStorage.getItem('datecookie')
  if(!date || date === null ){
    let control = localStorage.getItem('selectgeo')
    if(!control || control === null ){
      const response = await fetch(`${locationapi}/get-contry`, { headers })
      const json = await response.json();
      localStorage.setItem('objectGeo', JSON.stringify(json))
      localStorage.setItem('selectgeo', false)
      let date = Date.now()
      localStorage.setItem('datecookie', date)
      return json
    } else {
      const json = JSON.parse(localStorage.getItem('objectGeo'))
      return json
    }
  }else{
    let daterest = Date.now() - date
    if( daterest > 3600000 ){
      localStorage.clear()
    }
    let control = localStorage.getItem('selectgeo')
    if(!control || control === null ){
      const response = await fetch(`${locationapi}/get-contry`, { headers })
      const json = await response.json();
      localStorage.setItem('objectGeo', JSON.stringify(json))
      localStorage.setItem('selectgeo', false)
      let date = Date.now()
      localStorage.setItem('datecookie', date)
      return json
    } else {
      const json = JSON.parse(localStorage.getItem('objectGeo'))
      return json
    }
  }
}

export const getTagLocation = async (idTag) => {
  const response = await fetch(`${api}/tags/${idTag}`, { headers, method: 'GET' })
  const data = await response.json()
  let json = {
        "location": data.slug,
        "countryCode": data.slug,
        "idtag":{
          "term_id": data.id,
          "name": data.name,
          "slug": data.slug,
          "term_group":0,
          "term_taxonomy_id": data.id,
          "taxonomy":"post_tag",
          "description":"",
          "parent":0,
          "count":0,
          "filter":"raw"
        }
      }
  localStorage.setItem('selectgeo', true)
  localStorage.setItem('objectGeo',JSON.stringify(json))
  window.location.href = '/'
  return json
}

export const getCategoriesAll = async () =>{

  const response = await fetch(`${api}/categories`, { headers })
  const json = await response.json();
  return json
}


export const getPostAll = async (exlude) => {
  let json =[]
  const response = await fetch(`${api}/posts?categories_exclude=${exlude}&order=desc&_embed`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostCountryAll = async (exlude, excludecontry) => {
  let json =[]
  const response = await fetch(`${api}/posts?categories_exclude=${exlude}&tags=${excludecontry}&order=desc&_embed`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}


export const getPostbyCategory =  async (catId) => {
  let json =[]
  const response = await fetch(`${api}/posts?categories=${catId}&categories_exclude=1&order=desc&_embed`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostbyCategorybyCountry =  async (catId, excludecontry) => {
  let json =[]
  let url = `${api}/posts?categories=${catId}&tags=${excludecontry}&categories_exclude=1&order=desc&_embed`
  if(catId===71){
    url = `${url}&per_page=20`
  }
  if(catId===12){
    url = `${url}&per_page=30`
  }
  const response = await fetch(url, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostbyCategorybyCountryandPage =  async (catId, excludecontry, page) => {
  let json =[]
  let url = `${api}/posts?categories=${catId}&tags=${excludecontry}&categories_exclude=1&order=desc&_embed&page=${page}&_embed`
  if(catId===71){
    url = `${url}&per_page=20`
  }
  if(catId===12){
    url = `${url}&per_page=30`
  }
  const response = await fetch(url, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostbyCategoryexceptId =  async (catId, Idext) => {
  let json =[]
  const response = await fetch(`${api}/posts?categories=${catId}&exclude=${Idext}&categories_exclude=1&order=desc&_embed`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostbyCategoryexceptIdbyTag =  async (catId, Idext, excludecontry) => {
  let json =[]
  const response = await fetch(`${api}/posts?categories=${catId}&tags=${excludecontry}&categories_exclude=1,6&exclude=${Idext}&order=desc&per_page=3&_embed`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostbyCategoryparent =  async (catId) => {
  let json =[]
  const response = await fetch(`${api}/categories?parent=${catId}&categories_exclude=1&order=desc`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostbyCategoryparentexceptId =  async (catId, Idext) => {
  let json =[]
  const response = await fetch(`${api}/categories?parent=${catId}&exclude=${Idext}&order=desc`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostbyCategoryParent =  async (catObj, tagId) => {
  let json =[]
  const response = await fetch(`${api}/posts?categories=${catObj}&categories_exclude=1&tags=${tagId}&_embed`, { headers })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json
}

export const getPostPage = async (page, exlude) => {
  const response = await fetch(`${api}/posts?page=${page}&categories_exclude=${exlude}&order=desc&_embed `, { headers })
  const json = response.json()
  return json

}

export const getPostPageCategory = async (page, idcat) => {
  let url = `${api}/posts?page=${page}&categories=${idcat}&categories_exclude=1&order=desc&_embed`
  if(idcat===71){
    url = `${url}&per_page=20`
  }
  if(idcat===12){
    url = `${url}&per_page=30`
  }
  const response = await fetch(url, { headers })
  const json = response.json()
  return json

}

export const getPostbyId = (postId) =>
  fetch(`${api}/posts/${postId}`, { headers })
    .then(res => res.json())
    .then(data => data.post)

export const getPostbyIncludeId = async (ids) => {
  const response = await fetch(`${api}/posts?include=${ids}&order=desc&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getPostbySlug = async (slug) => {
  const response = await fetch(`${api}/posts?slug=${slug}&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getPostbySlugCountry = async (slug, excludecontry) => {
  const response = await fetch(`${api}/posts?slug=${slug}&tags=${excludecontry}&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getMenuAll = async () => {
  const response = await fetch(`${menuapi}/menu-locations`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getMenubySlug = async (slug) => {
  const response = await fetch(`${menuapivc}/menu/${slug}`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getMenubyId = async (id) => {
  const response = await fetch(`${menuapivc}/menu/${id}`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getMediabyid = async (idMedia) => {
  const response = await fetch(`${api}/media/${idMedia}`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getTagsbySlug = async (slug) => {
  const response = await fetch(`${api}/tags?slug=${slug}`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getTagsbySlugCountry = async (slug, excludecontry) => {
  const response = await fetch(`${api}/tags?slug=${slug}&tags=${excludecontry}&order=desc&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getTagbyid = async (idTag) => {
  const response = await fetch(`${api}/tag/${idTag}`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getPostbyTagid = async (idTag, idPost) => {
  const response = await fetch(`${api}/posts?tags=${idTag}&order=desc&per_page=100&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getPostbyTagidCountry = async (idTag, exclude) => {
  const response = await fetch(`${api}/posts?tags=${idTag},${exclude}&order=desc&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getCategorybyid = async (idCat) => {
  let url = `${api}/categories/${idCat}?order=desc`
  if(idCat===71){
    url = `${url}&per_page=20`
  }
  if(idCat===12){
    url = `${url}&per_page=30`
  }
  const response = await fetch(url, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getCategorybySlug = async (slug) => {
  const response = await fetch(`${api}/categories?slug=${slug}`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}


export const getPostbyCategorybyid = async (idCat) => {
  const response = await fetch(`${api}/posts?categories=${idCat}&order=desc&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}


export const getPostbyCategorybyidCountry = async (idCat, excludecontry) => {
  let url = `${api}/posts?categories=${idCat}&tags=${excludecontry}&order=desc&_embed`
  if(idCat===71){
    url = `${url}&per_page=20`
  }
  if(idCat===12){
    url = `${url}&per_page=30`
  }
  const response = await fetch(url, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}


export const getPagesbySlug = async (slug) => {
  const response = await fetch(`${api}/pages?slug=${slug}&_embed`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getDataSpreed = async (dataid, page) => {
  const response = await fetch(`${drivegoogle}list/${dataid}/${page}/public/values?alt=json`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const getSearchbystring = async (string) => {
  let json =[]
  const response = await fetch(`${api}/posts?search=${string}&_embed`, { headers, method: 'GET' })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json;
}

export const getSearchbystringbyCountry = async (string, excludecontry) => {
  let json =[]
  const response = await fetch(`${api}/posts?search=${string}&tags=${excludecontry}&order=desc&_embed`, { headers, method: 'GET' })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json;
}

export const getSearchbystringwithPage = async (string, page) => {
  let json =[]
  const response = await fetch(`${api}/posts?search=${string}&page=${page}&_embed`, { headers, method: 'GET' })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json;
}

export const getSearchbystringwithPagebyCountry = async (string, page, excludecontry) => {
  let json =[]
  const response = await fetch(`${api}/posts?search=${string}&tags=${excludecontry}&page=${page}&_embed`, { headers, method: 'GET' })
  json['page'] = response.headers.get("X-WP-TotalPages")
  json['data'] = await response.json()
  return json;
}

export const getSearchbystringbytag = async (string, tag) => {
  const response = await fetch(`${api}/posts?search=${string}&tags=${tag}`, { headers, method: 'GET' })
  const json = await response.json()
  return json;
}

export const newEmail = async (objemail) =>{
  var formData = new FormData();
  formData.append('form_name', objemail.form_name);
  formData.append('form_email', objemail.form_email);
  formData.append('form_msg', objemail.form_msg);
  formData.append('form_country', objemail.form_country);
  formData.append('form_asunt', objemail.form_asunt);

  const response = await fetch(`${emailapi}`, { method: 'POST', headers: {
    },
    body: formData
  })
  const json = await response
  return json;
}








// WEBPACK FOOTER //
// ./src/ReadableApi.js